import React, { Component } from 'react';
import Radium from 'radium';
import WMAppBar from '@workmarket/front-end-components/dist/WMAppBar';
import WMDrawer from '@workmarket/front-end-components/dist/WMDrawer';
import LeftNavMenuGroup from './LeftNavMenu/LeftNavMenuGroup';
import RightNavMenuGroup from './RightNavMenuGroup';
import WMSnackbar from '@workmarket/front-end-components/dist/WMSnackbar';
import WMLinearProgress from '@workmarket/front-end-components/dist/WMLinearProgress';
import $ from 'jquery';
import _ from 'underscore';
import AjaxSendInit from '../../funcs/ajaxSendInit';
import utils from '../utilities';

class Navigation extends Component {
	constructor(props){
		super(props);
		this.state = {
			open: props.config.isNavPinnedOpen,
			DynamicSupportBanner: null,
			appDrawerTop: '64px'
		};
	}

	componentDidMount() {
		/*Oh Jquery Monolith Shimmy Shim Shim Mounting Shim*/
		$(document).ready(() => this.jQueryContentMoveShim(this.props.config.isNavPinnedOpen));
		this.renderSupportBanner();
		this.addSmartBannerEventListeners();
	}

	handleToggleNavMenu() {
		this.setState({open: !this.state.open });
		AjaxSendInit();
		$.post('/nav/set_preferences', { open: !this.state.open });
		this.jQueryContentMoveShim(!this.state.open);
	}

	jQueryContentMoveShim(isOpen) {
		/*Oh Jquery Monolith Shimmy Shim Shim */
		if (isOpen && !utils.browser.isSmallMobile()) {
			$('#outer-container').css('margin-left','240px');
			$('.site-footer').css('margin-left','240px');
		} else {
			$('#outer-container').css('margin-left','0px');
			$('.site-footer').css('margin-left','0px');
		}
	}

	renderSupportBanner = () => {
		if (this.props.showSupportBanner && !this.state.DynamicSupportBanner) {
			import(
				/* webpackChunkName: "support-banner" */
				'./SupportBanner'
			).then((component) => {
				this.setState({ DynamicSupportBanner: component.default, appDrawerTop: '124px' });
			});
		}
	};

	addSmartBannerEventListeners = () => {
		document.addEventListener('smartbanner.exit', () => this.setState({ appDrawerTop: '64px' }));
		document.addEventListener('smartbanner.view', () => this.setState({ appDrawerTop: '146px' }));
	};

	render() {
		const styles = {
			Drawer: {
				position: 'fixed',
				top: !utils.appBarRemoved() ? this.state.appDrawerTop : 0,
				zIndex: '1200',
				paddingBottom: '64px',
				bottom: '0',
				height: 'auto',
			},
			AppBar: { backgroundColor: '#f7961d', position: 'fixed', left: 0, right: 0, zIndex: '1200' },
			LeftNavMobileHeader: {height: '64px', backgroundColor: '#f7961d', paddingTop: '8px'},
			LeftNavMobileHeaderLogo: { paddingTop: '7px',paddingLeft: '14px', float: 'left' },
			LeftNavMobileHeaderIcon: { float: 'right' },
			logo: {
				position: 'absolute',
				top: '50%',
				transform: 'translateY(-50%)',
				width: 140,
				height: 33
			}
		};

		if (utils.appBarRemoved()) {
			return (
				<div>
					<WMUploader status={this.props.config.uploadStatus} message={this.props.config.uploadMessage}/>
				</div>
			);
		}

		const { DynamicSupportBanner } = this.state;

		return (
			<div>
				<WMDrawer
					docked={utils.browser.isSmallMobile() ? false : true}
					open={this.state.open}
					width={240}
					containerStyle={styles.Drawer} >
					<LeftNavMenuGroup  navMenuItems={this.props.config.navMenuItems} activePage={this.props.config.breadcrumbPage} />
				</WMDrawer>

				<div style={ styles.AppBar } >
					{ DynamicSupportBanner && <DynamicSupportBanner /> }
					<WMAppBar
						title={
							<a href='/home'>
								<img
									alt="Work Market Logo"
									src={ this.props.config.adpWMlogoURI }
									style={ styles.logo }
								/>
							</a>
						}
						iconElementRight={ (
							<RightNavMenuGroup
								useZendesk={ this.props.config.useZendesk }
								useZoomChat={ this.props.config.useZoomChat }
								user={ this.props.config.currentUser }
								support={ this.props.config.support }
								hideSearchBar={ this.props.config.currentUser.isSellerOrgPayNavigation }
								hideNotifications={ this.props.config.currentUser.isSellerOrgPayNavigation }
							/>
						) }
						onLeftIconButtonClick={ this.handleToggleNavMenu.bind(this) }
					/>
				</div>
				<WMUploader status={this.props.config.uploadStatus} message={this.props.config.uploadMessage}/>
			</div>
		);
	}
}

class WMUploader extends Component {
	constructor(props){
		super(props);
		this.state = {
			status: props.status
		};
	}
	componentDidMount() {
		this.checkStatus();
	}
	checkStatus() {
			$.getJSON('/uploadProgress/progress', (res) => {
				if (res && res.data && !_.isUndefined(res.data.uploadProgress)) {
					setTimeout(()=> {
						this.setState({status: res.data.uploadProgress});
					}, 2000)

					if (res.data.uploadProgress === 1) {
						setTimeout(() => {
							this.setState({status: 0});
						}, 12000)
					}
				} else {
					setTimeout(this.checkStatus, 5000);
				}
			});
	}
	render() {
		if (this.props.status > 0 && this.props.status < 1) {
			return (
				<WMSnackbar style={{zIndex: '1200'}} bodyStyle={{backgroundColor:'rgba(0, 0, 0, 0.74)'}}
					open={!!this.state.status}
					message={
						this.state.status === 1 ?
							<div>
								<span>{this.props.message.done.title}</span>
								<span style={{paddingLeft:'20px'}}>
									<a href={this.props.message.done.link.href}> {this.props.message.done.link.text}</a>
								</span>
							</div> :
							<div>
								<span>{this.props.message.start.title}</span>
								<WMLinearProgress style={{
										position: 'absolute',
										top: '24px',
										width: '150px',
										margin: '0 0 0 96px'
									}}
									color='#F79626'
									mode="indeterminate"
									/>
							</div>
					}
					/>
			)
		}
		return null
	}
}

export default Navigation = Radium(Navigation);
